import { useTranslation } from "react-i18next";
import { usePropertyContext } from "../context/usePropertyContext";
import { WhiteBox, FoodsIconButton, FoodsIcon } from "@foodpilot/foods";
import { Box, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { sanitizeFilename } from "../context/utils/sanitizeFilename";

export const UploadedFile = () => {
    const { attachmentState, post } = usePropertyContext();

    const { t } = useTranslation();
    const theme = useTheme();
    const canAnswerSsq = post.canAnswerSsq === true;

    const { attachments, isUploading, deletingAttachmentId, downloadingAttachmentId } = attachmentState;

    if (attachments.length === 0) {
        if (canAnswerSsq && attachmentState.hasPendingFiles) {
            return null;
        }

        return (
            <Stack width={"100%"} flexDirection={"column"}>
                <WhiteBox
                    sx={{
                        width: "100%",
                        border: `dashed ${theme.palette.grey[500]}`,
                        padding: theme.spacing(1.5),
                    }}
                    borderRadius={theme.spacing(1)}
                >
                    <Stack flexDirection={"row"} alignItems="center" gap={theme.spacing(1)}>
                        <Box display="flex">
                            <FoodsIcon icon="addFile" size={4} />
                        </Box>
                        <Typography variant={"body-bold"}>
                            {t("property.file_upload_info.no_file", "No file added")}
                        </Typography>
                    </Stack>
                </WhiteBox>
            </Stack>
        );
    }

    return (
        <Stack width={"100%"} flexDirection={"column"} gap={theme.spacing(1)}>
            {attachments.map((attachment) => (
                <WhiteBox
                    key={attachment.id}
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        overflowWrap: "anywhere",
                    }}
                    padding={theme.spacing(2)}
                    alignItems="center"
                    borderRadius={theme.spacing(1)}
                >
                    <Stack gap={theme.spacing(0.5)}>
                        <Typography variant="body-medium">{sanitizeFilename(attachment.displayName)}</Typography>
                        <Typography variant="body2" color="textSecondary">
                            {attachment.createdAt}
                        </Typography>
                    </Stack>
                    <Stack flexDirection={"row"} gap={{ xs: theme.spacing(1), md: theme.spacing(2) }}>
                        <FoodsIconButton
                            size="s"
                            icon="exportDownload"
                            buttonProps={{
                                disabled: downloadingAttachmentId === attachment.id || isUploading,
                                onClick: () => {
                                    void attachmentState.downloadRemoteFile(attachment);
                                },
                            }}
                        />
                        {canAnswerSsq &&
                            (deletingAttachmentId === attachment.id ?
                                <Box alignContent={"center"}>
                                    <CircularProgress sx={{ color: theme.custom.red[500] }} size={"20px"} />
                                </Box>
                            :   <FoodsIconButton
                                    size="s"
                                    icon="delete"
                                    buttonProps={{
                                        sx: { color: theme.custom.red[500] },
                                        disabled: isUploading,
                                        onClick: () => attachmentState.deleteRemoteFile(attachment),
                                    }}
                                />)}
                    </Stack>
                </WhiteBox>
            ))}
        </Stack>
    );
};
